import React from "react";
import { Modal, Button, Typography } from "antd";

const { Text } = Typography;

function ConfirmationModal({
  visible,
  onCancel,
  onConfirm,
  loading = false,
  message = "Are you sure?",
}) {
  return (
    <Modal
      title="Confirm"
      visible={visible}
      centered
      onCancel={onCancel}
      bodyStyle={{ borderRadius: 8, padding: 30, minHeight: 100 }}
      style={{ borderRadius: 8, overflow: "hidden", minWidth: 450 }}
      footer={[
        <Button key="cancel" onClick={onCancel} style={{ minWidth: 80 }}>
          No
        </Button>,
        <Button
          key="confirm"
          type="primary"
          style={{ minWidth: 80 }}
          loading={loading}
          onClick={onConfirm}
        >
          Yes
        </Button>,
      ]}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 18,
          color: "#333",
          fontWeight: 400,
        }}
      >
        <Text>
          Are you sure you want to update the{" "}
          <span
            style={{
              color: "#FAAD14",
            }}
          >
            {message}
          </span>
        </Text>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
